import { Link, useLocation } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import styles from './NotFoundPage.module.css';

/**
 * Catch-all route target. Previously an unmatched path rendered the header and
 * footer around an empty body; this gives a clear message and a way back.
 *
 * A mistyped admin URL sends the admin back to the admin app rather than the
 * customer orders page.
 */
export function NotFoundPage() {
  usePageTitle('Page not found');
  const { pathname } = useLocation();
  const isAdminPath = pathname.startsWith('/admin');

  return (
    <main className={styles.page}>
      <h1 className={styles.heading}>Page not found</h1>
      <p className={styles.text}>
        We couldn't find the page you were looking for. It may have moved, or the
        link may be out of date.
      </p>
      {isAdminPath ? (
        <Link to="/admin/orders" className={styles.link}>
          Back to admin orders
        </Link>
      ) : (
        <Link to="/orders" className={styles.link}>
          Back to your orders
        </Link>
      )}
    </main>
  );
}
